import React, { FC, memo, useEffect, useState } from 'react';
import { UspSimple } from '~/lib/data-contract';
import { Usp } from '~/shared/components';
import styles from './usp-list.module.css';

type Props = {
    items?: UspSimple[];
};

const USPList: FC<Props> = memo(({ items }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (!items || items.length <= 1) return;
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % items.length);
        }, 5000); // 5 seconds
        return () => clearInterval(interval);
    }, [items]);

    if (!items || items.length === 0) return null;

    return (
        <div className={styles.root}>
            <ul className={styles.list}>
                {items.map((usp, index) => (
                    <li
                        key={index}
                        className={index === activeIndex ? styles.active : styles.inactive}
                    >
                        <Usp className={styles.uspItem} uspItem={usp} />
                    </li>
                ))}
            </ul>
        </div>
    );
});

USPList.displayName = 'USPList';
export default USPList;
